export type DailyStat = {
  date: string
  clicks: number
  views: number
  exchangeClicks: number
  exchangeViews: number
  exchangeCost: number
}

export type LastWeekCompletion = {
  lastWeekMatchedViewsPerDay: number
  totalViewsPerDay: number
  percent: number
}

export type ProjectedViews = {
  projectedTotalViews: number
  totalViews: number
  percent: number
}

export type CampaignHealth = {
  exchangeCurrency: string
  lastWeekCompletion: LastWeekCompletion
  projectedViews: ProjectedViews
  dailyViewsToDeliver: number
  dailyStats: DailyStat[]
}

const lastWeekCompletionFromServer = (x?: any): LastWeekCompletion =>
  x
    ? {
        lastWeekMatchedViewsPerDay: x.last_week_matched_views_per_day,
        totalViewsPerDay: x.total_views_per_day,
        percent: x.percent,
      }
    : { lastWeekMatchedViewsPerDay: 0, totalViewsPerDay: 0, percent: 0 }

const projectedViewsFromServer = (x?: any): ProjectedViews =>
  x
    ? { projectedTotalViews: x.projected_total_views, totalViews: x.total_views, percent: x.percent }
    : { projectedTotalViews: 0, totalViews: 0, percent: 0 }

const dailyStatFromServer = (x?: any): DailyStat =>
  x
    ? {
        date: x.date,
        clicks: x.clicks,
        views: x.views,
        exchangeClicks: x.exchange_clicks,
        exchangeViews: x.exchange_views,
        exchangeCost: x.exchange_cost,
      }
    : { date: '', clicks: 0, views: 0, exchangeClicks: 0, exchangeViews: 0, exchangeCost: 0 }

export const campaignHealthFromServer = (x?: any): CampaignHealth =>
  x
    ? {
        exchangeCurrency: x.exchange_currency,
        lastWeekCompletion: lastWeekCompletionFromServer(x.last_week_completion),
        projectedViews: projectedViewsFromServer(x.projected_views),
        dailyViewsToDeliver: x.daily_views_to_deliver,
        dailyStats: (x.daily_stats || []).map(dailyStatFromServer),
      }
    : {
        exchangeCurrency: '',
        lastWeekCompletion: lastWeekCompletionFromServer(),
        projectedViews: projectedViewsFromServer(),
        dailyViewsToDeliver: 0,
        dailyStats: [],
      }
